module.exports = __webpack_public_path__ + "img/cloud-solutions.b8b465fd.svg";